import React from 'react';
import {
  BuildingConstruction,
  BuildingConstructionDetails,
  LandUseChange,
  RoadPavement,
} from '../../../../../../services/types/Calculator';
import {
  EmissionsPurchasedElectricity,
  EmissionsRoadMaintenanceActivities,
  TransportContextType,
} from '../../../../../../services/types/CalculatorTransportRoads';

const emptyLandUseChange: LandUseChange = {
  moduleId: 0,
  name: '',
  coversType: [],
  rows: [],
  subTotal: null,
  infoUrl: null,
};

const emptyRoadPavementTransport: RoadPavement = {
  moduleId: 0,
  name: '',
  factorValue: 0,
  factorWidth: 0,
  sqFeetToSqMeters: 0,
  sqDefaultEmission: 0,
  isTotalAreaKnown: null,
  totalArea: null,
  pavedRoadLength: null,
  numberOfLanes: null,
  subTotal: null,
  pavedRoadArea: 0,
  totalAreaRoadRehabilitated: 0,
};

const emptyEmissionsRoadMaintenanceActivities: EmissionsRoadMaintenanceActivities = {
  moduleId: 0,
  name: '',
  factorValue: 0,
  subTotal: null,
  area: null,
};

const emptyEmissionsDevelopmentBuildingConstructionDetails: BuildingConstructionDetails = {
  id: 0,
  name: '',
  defaultFactor: 0,
  defaultArea: null,
  emissions: null,
  avgMaterial: 0,
};

const emptyEmissionsDevelopmentBuildingConstruction: BuildingConstruction = {
  moduleId: 0,
  name: '',
  subTotal: null,
  isEstimated: null,
  totalArea: null,
  buildingsType: [],
  columns: emptyEmissionsDevelopmentBuildingConstructionDetails,
  floors: emptyEmissionsDevelopmentBuildingConstructionDetails,
  exteriorWalls: emptyEmissionsDevelopmentBuildingConstructionDetails,
  windows: emptyEmissionsDevelopmentBuildingConstructionDetails,
  interiorWalls: emptyEmissionsDevelopmentBuildingConstructionDetails,
  roofs: emptyEmissionsDevelopmentBuildingConstructionDetails,
  rows: [],
};

const emptyEmissionsPurchasedElectricity: EmissionsPurchasedElectricity = {
  moduleId: 0,
  name: '',
  countryName: '',
  countryFactor: 0,
  amountElectricityConsumed: null,
  subTotal: null,
};

const Context = React.createContext<TransportContextType>({
  calculateId: null,
  operationId: null,
  country: null,
  sector: null,
  sectorId: null,
  landUseChange: emptyLandUseChange,
  roadPavementTransport: emptyRoadPavementTransport,
  emissionsRoadMaintenanceActivities: emptyEmissionsRoadMaintenanceActivities,
  emissionsDevelopmentBuildingConstruction: emptyEmissionsDevelopmentBuildingConstruction,
  emissionsPurchasedElectricity: emptyEmissionsPurchasedElectricity,
  totalConstructionOverriden: null,
  totalOperationOverriden: null,
  reload: () => {},
  isFinished: false,
});

export default Context;
